import {
  DEFAULT_DAY_BACKGROUND,
  DEFAULT_QUOTATION_BACKGROUND,
  QUOTATION_PAGE,
  LOGIN_PAGE,
  PATRIOTIC_BACKGROUND,
  PATRIOTIC_QUOTATION_BACKGROUND,
  XMAS_DAY_BACKGROUND,
  XMAS_NIGHT_BACKGROUND,
  CALCULATOR_PAGE,
  DEFAULT_CALCULATOR_BACKGROUND,
} from '../../constants/backgroundThemes';

const festivitiesLogic = (month: number, defaultBackground: string): string => {
  if (month === 11) {
    return PATRIOTIC_QUOTATION_BACKGROUND;
  }

  if (month === 12) {
    return XMAS_DAY_BACKGROUND;
  }

  return defaultBackground;
};

/** It returns the correct img background depending on month festivities */
export default function getCurrentMonthTheme(
  date: Date,
  page: string,
  isNight = false,
): string {
  const month = date.getMonth() + 1;
  switch (page) {
    case LOGIN_PAGE:
      if (month === 11) {
        return PATRIOTIC_BACKGROUND;
      }
      if (month === 12 && isNight) {
        return XMAS_NIGHT_BACKGROUND;
      }
      if (month === 12) {
        return XMAS_DAY_BACKGROUND;
      }
      return DEFAULT_DAY_BACKGROUND;
    case QUOTATION_PAGE:
      return festivitiesLogic(month, DEFAULT_QUOTATION_BACKGROUND);
    case CALCULATOR_PAGE:
      return festivitiesLogic(month, DEFAULT_CALCULATOR_BACKGROUND);
    default:
      return DEFAULT_DAY_BACKGROUND;
  }
}
